module.exports = function () {
    return new Worker(__webpack_public_path__ + "d1cb694570f0bf554223.worker.js");
};
